import { SuccessAction } from "../../../../src";
import {
    ActionsUnion,
    createAction,
    createMetaAction,
} from "../../../components/reducer/actionHelpers";
import { Attachment, RelodeApiError } from "../../../modules";

export enum messageComposerActionNames {
    GET_UNREAD = "GET_UNREAD",
    GET_UNREAD_SUCCESS = "GET_UNREAD_SUCCESS",
    SEND_MESSAGE = "SEND_MESSAGE",
    SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS",
    SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE",
    CLEAR_ERROR = "CLEAR_ERROR",
    CLEAR_FILE_ATTACHMENTS = "CLEAR_FILE_ATTACHMENTS",
    SET_MESSAGE_CONTEXT = "SET_MESSAGE_CONTEXT",
    UPDATE_UNREAD_COUNT = "UPDATE_UNREAD_COUNT",
    FILE_ATTACHMENT_UPLOAD_STARTED = "FILE_ATTACHMENT_UPLOAD_STARTED",
    FILE_ATTACHMENT_UPLOAD_SUCCESS = "FILE_ATTACHMENT_UPLOAD_SUCCESS",
    FILE_ATTACHMENT_UPLOAD_FAILURE = "FILE_ATTACHMENT_UPLOAD_FAILURE",
    UPDATE_FILE_ATTACHMENTS = "UPDATE_FILE_ATTACHMENTS",

    COPY_FILE_ATTACHMENTS_STARTED = "COPY_FILE_ATTACHMENTS_STARTED",
    COPY_FILE_ATTACHMENTS_SUCCESS = "COPY_FILE_ATTACHMENTS_SUCCESS",
    COPY_FILE_ATTACHMENTS_FAILURE = "COPY_FILE_ATTACHMENTS_FAILURE",
}

export const creators = {
    getUnread: () => createAction(messageComposerActionNames.GET_UNREAD),
    getUnreadSuccess: (count: number) =>
        createAction(messageComposerActionNames.GET_UNREAD_SUCCESS, { count }),
    clearError: () => createAction(messageComposerActionNames.CLEAR_ERROR),
    clearFileAttachments: () =>
        createAction(messageComposerActionNames.CLEAR_FILE_ATTACHMENTS),
    sendMessage: () => createAction(messageComposerActionNames.SEND_MESSAGE),
    sendMessageSuccess: () =>
        createAction(messageComposerActionNames.SEND_MESSAGE_SUCCESS),
    sendMessageFailure: (error: RelodeApiError) =>
        createAction(messageComposerActionNames.SEND_MESSAGE_FAILURE, {
            error,
        }),
    setMessageContext: (context: {
        userId: number;
        userName: string;
        jobId: number;
        jobName: string;
    }) =>
        createAction(messageComposerActionNames.SET_MESSAGE_CONTEXT, {
            ...context,
        }),

    attachmentStartUpload: () =>
        createAction(messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_STARTED),
    attachmentUploadSucceeded: (attachment: Attachment) =>
        createMetaAction(
            messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_SUCCESS,
            new SuccessAction("uploaded attachment"),
            { attachment }
        ),
    attachmentUploadFailed: (message?: string, apiError?: RelodeApiError) =>
        createAction(
            messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_FAILURE,
            {
                message,
                apiError,
            }
        ),

    updateAttachments: (attachments: Attachment[]) =>
        createAction(messageComposerActionNames.UPDATE_FILE_ATTACHMENTS, {
            attachments,
        }),

    copyAttachmentsStarted: () =>
        createAction(messageComposerActionNames.COPY_FILE_ATTACHMENTS_STARTED),
    copyAttachmentsSucceeded: (attachments: Attachment[]) =>
        createAction(messageComposerActionNames.COPY_FILE_ATTACHMENTS_SUCCESS, {
            attachments,
        }),
    copyAttachmentsFailed: (message?: string, apiError?: RelodeApiError) =>
        createAction(messageComposerActionNames.COPY_FILE_ATTACHMENTS_FAILURE, {
            message,
            apiError,
        }),
};

export type MessageComposerActionTypes = ActionsUnion<typeof creators>;
